import type { ProjectListFilters } from "./types";

export const projectKeys = {
  all: ["projects"] as const,
  list: (filters: ProjectListFilters) =>
    [...projectKeys.all, "list", filters] as const,
};
